export const MONTH_ORDER: Record<string, number> = {
  Jan: 1,
  Feb: 2,
  Mar: 3,
  Apr: 4,
  May: 5,
  Jun: 6,
  Jul: 7,
  Aug: 8,
  Sep: 9,
  Oct: 10,
  Nov: 11,
  Dec: 12,
};

export const CATEGORY_ORDER = {
  MONTH: 1,
  QUARTER: 2,
  YEAR: 3,
  SUMMER: 4,
  WINTER: 5,
  CALENDAR: 6,
  EMISSIONS: 7,
  OTHER: 8,
} as const;

type CategoryType = keyof typeof CATEGORY_ORDER;

export function getCategoryType(periodType: string): CategoryType {
  const lowerType = periodType.toLowerCase();

  if (periodType in MONTH_ORDER) return "MONTH";
  if (lowerType.startsWith("q")) return "QUARTER";
  if (lowerType.startsWith("y")) return "YEAR";
  if (lowerType.includes("sum")) return "SUMMER";
  if (lowerType.includes("win")) return "WINTER";
  if (lowerType === "cal") return "CALENDAR";
  if (lowerType.includes("next")) return "EMISSIONS";

  return "OTHER";
}

export function getPeriodOrder(type: string): number {
  try {
    const { type: periodType, year } = parsePeriodCode(type);

    const categoryType = getCategoryType(periodType);
    const categoryValue = CATEGORY_ORDER[categoryType] * 10000;

    // Within each category, sort by year first
    const yearValue = year !== null ? year * 100 : 0;

    // Then by month order for months
    let withinTypeOrder = 0;
    if (categoryType === "MONTH" && periodType in MONTH_ORDER) {
      withinTypeOrder = MONTH_ORDER[periodType];
    } else if (categoryType === "QUARTER" && periodType.length > 1) {
      // Extract quarter number (Q1, Q2, etc.)
      const quarterNum = parseInt(periodType.substring(1), 10);
      withinTypeOrder = !isNaN(quarterNum) ? quarterNum : 0;
    } else if (categoryType === "YEAR" && periodType.length > 1) {
      // Extract year number (Y1, Y2, etc.)
      const yearNum = parseInt(periodType.substring(1), 10);
      withinTypeOrder = !isNaN(yearNum) ? yearNum : 0;
    }

    return categoryValue + yearValue + withinTypeOrder;
  } catch (e) {
    console.error("Error getting category order", e);
    return 0;
  }
}

export function parsePeriodCode(code: string): { type: string; year: number | null } {
  if (code.includes("-")) {
    const [type, yearStr] = code.split("-");
    const year = parseInt(yearStr, 10);
    return { type, year: isNaN(year) ? null : year };
  }

  return { type: code, year: null };
}
